import { useEffect, useState } from "react";
import { useWebSocketContext } from "../context/WebSocketProvider";

export const useWebSocket = () => {
  const { socket, connected } = useWebSocketContext();

  return { socket, connected };
};
